import { defineMessages } from "react-intl";
export default defineMessages({
    addonList: {
        id: "addons.addonList",
        defaultMessage: "Add-on list",
    },
    ambientWeatherCreateAndRetrieveApiKey: {
        id: "addons.ambientWeatherCreateAndRetrieveApiKey",
        defaultMessage: "Create and retrieve your API key from this link",
    },
    ambientWeatherDescription: {
        id: "addons.ambientWeatherDescription",
        defaultMessage: "Ambient Weather stations (WS-5000, WS-2000, WS-2902C,...)",
    },
    apiKey: {
        id: "addons.apiKey",
        defaultMessage: "API key",
    },
    applicationKey: {
        id: "addons.applicationKey",
        defaultMessage: "Application key",
    },
    connect: {
        id: "addons.connect",
        defaultMessage: "Connect",
    },
    davisApiSecret: {
        id: "addons.davisApiSecret",
        defaultMessage: "API Secret",
    },
    davisApiV2Key: {
        id: "addons.davisApiV2Key",
        defaultMessage: "V2 API Key",
    },
    davisDescription: {
        id: "addons.davisDescription",
        defaultMessage: "Davis weather stations (Vantage Vue, Vantage Pro2,...)",
    },
    davisRetrieveApiKey: {
        id: "addons.davisRetrieveApiKey",
        defaultMessage: "Retrieve your V2 API keys from this link",
    },
    disconnect: {
        id: "addons.disconnect",
        defaultMessage: "Disconnect",
    },
    ecowittCreateAndRetrieveKeys: {
        id: "addons.ecowittCreateAndRetrieveKeys",
        defaultMessage: "Create and retrieve both an API key and an application key from this link",
    },
    ecowittDescription: {
        id: "addons.ecowittDescription",
        defaultMessage: "Ecowitt provides professional wifi weather station, wireless indoor outdoor thermometers, humidity monitors, high precision rain gauges, air quality monitors and more.",
    },
    helpLink: {
        id: "addons.helpLink",
        defaultMessage: "How to connect {provider}",
    },
    myAcuriteAccountOnHold: {
        id: "addons.myAcuriteAccountOnHold",
        defaultMessage: "Your account has been placed on hold. Please enter your password to reconnect your account",
    },
    myAcuriteDescription: {
        id: "addons.myAcuriteDescription",
        defaultMessage: "AcuRite is the #1 weather station brand in North America. As a leader in time, temperature, and weather technology, AcuRite provides you with detailed information about your indoor and outdoor environment so you can plan your day with confidence.",
    },
    myAcuriteEnterCredentials: {
        id: "addons.myAcuriteEnterCredentials",
        defaultMessage: "Enter your My AcuRite credentials in order to link your My AcuRite account with SmartMixin",
    },
    netatmoEnergy: {
        id: "addons.netatmoEnergy",
        defaultMessage: "Netatmo Energy",
    },
    netatmoEnergyDescription: {
        id: "addons.netatmoEnergyDescription",
        defaultMessage: "Use your Netatmo Thermostat to change your home's temperature, from your bed or from the other side of the world.",
    },
    netatmoThermostat: {
        id: "addons.netatmoThermostat",
        defaultMessage: "Netatmo Thermostat",
    },
    netatmoWeather: {
        id: "addons.netatmoWeather",
        defaultMessage: "Netatmo Weather",
    },
    netatmoWeatherDescription: {
        id: "addons.netatmoWeatherDescription",
        defaultMessage: "Your personal weather station at home",
    },
    or: {
        id: "addons.or",
        defaultMessage: "or",
    },
    providerAccountDisconnected: {
        id: "addons.providerAccountDisconnected",
        defaultMessage: "The connection to your weather service has expired. Please reconnect to resume data updates.",
    },
    reconnect: {
        id: "addons.reconnect",
        defaultMessage: "Reconnect",
    },
    weatherflowCreateToken: {
        id: "addons.weatherflowCreateToken",
        defaultMessage: "Create and retrieve your token from this link",
    },
    weatherflowTempestDescription: {
        id: "addons.weatherflowTempestDescription",
        defaultMessage: "Tempest Weather System with Built-in Wind Meter, Rain Gauge",
    },
    wundergroundApiKey: {
        id: "addons.wundergroundApiKey",
        defaultMessage: "API key",
    },
    wundergroundDescription: {
        id: "addons.wundergroundDescription",
        defaultMessage: "Weather Underground is a global community of people connecting data from environmental sensors like weather stations and air quality monitors so we can provide the rich, hyperlocal data you need to power your passions",
    },
    wundergroundRetrieveApiKey: {
        id: "addons.wundergroundRetrieveApiKey",
        defaultMessage: "Retrieve your API key from this link",
    },
    wundergroundRetrieveStationId: {
        id: "addons.wundergroundRetrieveStationId",
        defaultMessage: "Retrieve your station ID from this link",
    },
    wundergroundStationId: {
        id: "addons.wundergroundStationId",
        defaultMessage: "Station ID",
    },
});
